<template>
  <v-container
    data-vue-component-name="Instruction"
    class="justify-center"
    fill-height
    fluid
  >
    <v-card
      flat
      max-width="500"
      class="d-flex flex-column align-center"
    >
      <v-card-title>Instructions</v-card-title>
      <v-card-text v-html="getInstructions" class="text-center" />
      <v-btn class="text-capitalize" @click="toNextPage">Let's begin</v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import onSpace from '@/mixins/onSpace';

export default {
  name: 'Instruction',
  mixins: [onSpace],
  data: () => ({
    onSpaceHandler: 'toNextPage',
  }),
  computed: {
    ...mapState({
      getInstructions: (_state, getters) => getters.getInstructions,
      currentExercise: state => state.currentExercise,
    }),
  },
  methods: {
    toNextPage() {
      this.$store.commit('SET_CURRENT_STEP', 2);

      this.$router.push({
        name: this.$store.getters.getStepView,
        params: {
          id: this.currentExercise + 1,
        },
      });
    },
  },
};
</script>
